import React, { useEffect } from 'react'
import Navbar from '../../components/Navbar'
import FeatureHighlight from '../../components/cultivars/FeatureHighlight'
import ProductShowcase from '../../components/cultivars/Jealousy/ProductShowcase'
import Footer from '../../components/Footer'
import CultivarDisplay from "../../components/cultivars/CultivarDisplay";
import Cta from "../../components/Cta";
import { Helmet } from 'react-helmet'

const Jealousy = () => {
   useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  return (
    <>
     <Helmet>
        <title>Jealousy - Bold Strain with Sweet & Sour Aroma | BeyondBloom™</title>
        <meta
          name="description"
          content="Jealousy is a bold cannabis strain with a sweet and sour aroma that leaves a lasting impression. Explore its unique flavor and effects today!"
        />
        <meta
          name="keywords"
          content="Jealousy strain, cannabis, sweet and sour aroma, premium cannabis, BeyondBloom"
        />
        <meta name="author" content="BeyondBloom™" />

        {/* Open Graph (Facebook & LinkedIn) */}
        <meta
          property="og:title"
          content="Jealousy - Bold Strain with Sweet & Sour Aroma | BeyondBloom™"
        />
        <meta
          property="og:description"
          content="Jealousy is a bold cannabis strain with a sweet and sour aroma that leaves a lasting impression. Explore its unique flavor and effects today!"
        />
        <meta property="og:image" content="/images/jealousy.png" />
        <meta property="og:url" content="https://yourwebsite.com/cultivars/jealousy" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Jealousy - Bold Strain with Sweet & Sour Aroma | BeyondBloom™"
        />
        <meta
          name="twitter:description"
          content="Jealousy is a bold cannabis strain with a sweet and sour aroma that leaves a lasting impression. Explore its unique flavor and effects today!"
        />
        <meta name="twitter:image" content="/images/jealousy.png" />
      </Helmet>
    <Navbar/>
    <ProductShowcase/>
    <FeatureHighlight/>
    <CultivarDisplay />
    <Cta />
    <Footer/>
</>
  )
}

export default Jealousy